export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-cyan-400/20">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Left: Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/2eb6d130082f2a600b74ebcd6904a72d/214316b3ea891be4a4b52d2997f81811.png" 
                alt="Bayfront Intelligence" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
              Empowering home service businesses with AI automation that captures leads, books jobs, and drives growth 24/7.
            </p>

            {/* Contact Info */}
            <div className="space-y-3 mb-6">
              <a href="tel:8139479302" className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm group">
                <span className="w-8 h-8 flex items-center justify-center rounded-full border border-cyan-400/30 group-hover:border-cyan-400 transition-colors duration-300">
                  <i className="ri-phone-line text-cyan-400 text-sm"></i>
                </span>
                (813) 947-9302
              </a>
              <a href="mailto:judah@bayfrontintelligence.com" className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm group">
                <span className="w-8 h-8 flex items-center justify-center rounded-full border border-cyan-400/30 group-hover:border-cyan-400 transition-colors duration-300">
                  <i className="ri-mail-line text-cyan-400 text-sm"></i>
                </span>
                judah@bayfrontintelligence.com
              </a>
              <div className="flex items-center gap-3 text-gray-400 text-sm">
                <span className="w-8 h-8 flex items-center justify-center rounded-full border border-cyan-400/30">
                  <i className="ri-map-pin-line text-cyan-400 text-sm"></i>
                </span>
                Tampa Bay, FL
              </div>
            </div>

            {/* Newsletter */}
            <div className="space-y-3">
              <label className="text-white font-semibold text-sm">Stay Updated</label>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 bg-transparent border-b-2 border-cyan-400/30 px-3 py-2 text-white placeholder-gray-500 focus:border-cyan-400 focus:outline-none transition-colors text-sm"
                />
                <button className="px-6 py-2 bg-transparent border-2 border-cyan-400 text-cyan-400 font-semibold rounded-full hover:bg-cyan-400 hover:text-black transition-all duration-300 text-sm whitespace-nowrap">
                  Subscribe
                </button>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Services</h3>
            <ul className="space-y-3">
              {['AI Voice Agents', 'Smart Calendars', 'Website Design', 'Lead Capture', 'Automated Follow-Up', 'CRM Automation'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 hover:text-cyan-400 hover:translate-x-1 inline-block transition-all duration-300 text-sm">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-3">
              {['About Us', 'How It Works', 'Case Studies', 'Pricing', 'Contact', 'Careers'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 hover:text-cyan-400 hover:translate-x-1 inline-block transition-all duration-300 text-sm">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Resources</h3>
            <ul className="space-y-3">
              {['Blog', 'Help Center', 'Documentation', 'API', 'Community', 'Partners'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 hover:text-cyan-400 hover:translate-x-1 inline-block transition-all duration-300 text-sm">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">
            © 2025 Bayfront Intelligence. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors text-xs">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors text-xs">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors text-xs">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}